import type { AceConversation, CraveDocSubmission, ExternalApply, JSTAceConversationResult, JSTCraveDocSubmissionResult, JSTExternalApplyResult, JSTModalScreen, JSTOpenModalResult, JSTSourcingOptInResult, JSTViewJobResult, SourcingOptIn, ViewJob } from './JSTModalScreen';

import TypedNativeModules from '../internal/TypedNativeModules';

export function openModal(modalScreen: ViewJob, from: string | null): Promise<JSTViewJobResult>;
export function openModal(modalScreen: AceConversation, from: string | null): Promise<JSTAceConversationResult>;
export function openModal(modalScreen: CraveDocSubmission, from: string | null): Promise<JSTCraveDocSubmissionResult>;
export function openModal(modalScreen: ExternalApply, from: string | null): Promise<JSTExternalApplyResult>;
export function openModal(modalScreen: SourcingOptIn, from: string | null): Promise<JSTSourcingOptInResult>;
export function openModal(modalScreen: JSTModalScreen, from: string | null): Promise<JSTOpenModalResult | void>;
export async function openModal(
    modalScreen: JSTModalScreen,
    from: string | null,
): Promise<void | JSTViewJobResult | JSTAceConversationResult | JSTCraveDocSubmissionResult | JSTExternalApplyResult | JSTSourcingOptInResult | JSTOpenModalResult> {
    return await TypedNativeModules.RNJSTNavigator?.openModal?.(
        modalScreen,
        from,
    );
}
